import i18n, { i18n_t } from '@/locales/i18n';
// 引入 compositions
import { SecuritySetting } from '@/renderer/components/dialog/setting/composition/securitySettingHandler';

// 引入工具类
import { IpcEvents } from '@/ipc-events';
import uploadTaskManager from '@/renderer/scripts/utils/upload/index';
import downloadTaskManager from '@/renderer/scripts/utils/download/index';
import transmissionDBManager from '@/renderer/scripts/utils/TransmissionDBManager';
import storage from '@/renderer/scripts/utils/storage';
import accessTokenManager from '@/renderer/scripts/utils/AccessTokenManager/space';
import shareAccessTokenManager from '@/renderer/scripts/utils/AccessTokenManager/share';
import user from '@/renderer/scripts/utils/user';
import store from '@/renderer/store';
import wsManager from '@/renderer/scripts/utils/wsManager';
import '@/renderer/scripts/utils/AccessTokenManager/collect';
import ipc from '@/renderer/scripts/utils/ipc';
import smh from '@/renderer/scripts/smh';
import {
  IS_BROWSER,
  IS_DEV,
  IS_PC_IN_LINUX,
  IS_PC_IN_MAC,
  IS_PC_IN_WIN,
  IS_PRIVATE,
  platform,
} from '@/common/constant/platform';
import { coSync } from '@/renderer/scripts/CoSync/coSync';

const { currVersion, serverPrefix, serverSuffix } = store.getters;
if (!IS_DEV && !IS_PRIVATE) {
  // 上报访问记录
  setTimeout(() => {
    let query = `platform=${platform}&version=${currVersion}&t=${new Date().getTime()}`;
    if (!IS_BROWSER) {
      query += `&systemVersion=${process.getSystemVersion()}`;
    }
    const url = `${serverPrefix + serverSuffix}/client.js?${query}`;
    const visitScript = document.createElement('script');
    visitScript.type = 'text/javascript';
    visitScript.src = url;
    document.head.appendChild(visitScript);
  }, 5000);
}

// 停止上传、下载任务
function cancelTask() {
  uploadTaskManager.cancel('all');
  downloadTaskManager.cancel('all');
}

// 清理本地缓存
function delStorage() {
  storage.del(storage.StoreKey.TEAM_PATH);
  storage.del(storage.StoreKey.RECV_SHARE_SPACE);
  storage.del(storage.StoreKey.RECYCLE_PATH);
  storage.del(storage.StoreKey.NOT_SHOW_TOP_ADVERT);
  storage.del(storage.StoreKey.NOT_SHOW_RECYCLE_ADVERT);
}
let visitScript!: HTMLScriptElement;
function visitRequest() {
  const baseQurey = `platform=${platform}&version=${currVersion}&t=${new Date().getTime()}`;
  const { organizationId, userId, phoneNumber } = user.getUserInfo();
  const loginQuery = `orgId=${organizationId}&userId=${userId}&phoneNum=${phoneNumber}&${baseQurey}`;
  const url = `${serverPrefix + serverSuffix}/api/visit.js?${baseQurey}&${loginQuery}`;
  if (visitScript) {
    visitScript.parentNode?.removeChild(visitScript);
  }
  visitScript = document.createElement('script');
  visitScript.type = 'text/javascript';
  visitScript.src = url;
  setTimeout(() => {
    document.head.appendChild(visitScript);
  }, 1000);
}
function reportAntiRansomwareInfo() {
  setTimeout(() => {
    coSync
      .center()
      .haveSyncTask()
      .then(async ret => {
        const haveBackup = ret;
        let haveFileHistory = false;
        try {
          const res = await smh.userAPI.getLibraryHistoryExtension();
          const { enableFileHistory } = res.data;
          haveFileHistory = enableFileHistory;
        } catch (e) {
          logger.ui.error('reportAntiRansomwareInfo error', e);
        }
        const securitySetting = storage.get(storage.StoreKey.SECURITY_SETTING) as SecuritySetting;
        reporter.report('anti_ransomware_state', {
          risk_sniffing: securitySetting.isbaitOpen,
          synchronized_disk: haveBackup,
          history_version: haveFileHistory,
        });
      });
  }, 1000 * 30);
}
async function checkAntiRansomwareState(e: any, props: any) {
  reporter.report('anti_ransomware_state', {
    file_diff: props.fileDiff,
    copy_error: props.copyError,
    notify: true,
  });
  // 收到状态变更
  if (props.fileDiff) {
    // 文件发送变更
    try {
      const os = (window.parent as any).require('os') as typeof import('os');
      let deviceType = 0;
      if (IS_PC_IN_MAC) {
        deviceType = 1;
      }
      if (IS_PC_IN_WIN) {
        deviceType = 2;
      }
      if (IS_PC_IN_LINUX) {
        deviceType = 3;
      }
      const params = {
        equipment: os.hostname(),
        deviceType,
      };
      await smh.userAPI.ransomwareWarn(params);
    } catch (error) {
      logger.ui.error('VIRUS_CHECK_STATE virus', error);
    }
  } else if (props.copyError) {
    // 检测出现异常 TODO 很异常场景，后续再看要不要加提示
    logger.ui.error('VIRUS_CHECK_STATE copyError');
    // tips.error('风险嗅探功能异常');
    const storageSecuritySetting = storage.get(storage.StoreKey.SECURITY_SETTING) as SecuritySetting;
    storageSecuritySetting.isbaitOpen = false;
    storage.set(storage.StoreKey.SECURITY_SETTING, storageSecuritySetting);
  }
}
function startAntiRansomwareCheck() {
  if (IS_BROWSER) {
    return;
  }
  const storageSecuritySetting = storage.get(storage.StoreKey.SECURITY_SETTING) as SecuritySetting;
  if (storageSecuritySetting.isbaitOpen) {
    // 如果是开启了防勒索功能
    logger.ui.info('startAntiRansomwareCheck');
    ipc.invoke(IpcEvents.VIRUS_CHECK, {
      startCheck: true,
      init: false,
    });
  }
  ipc.on(IpcEvents.VIRUS_CHECK_STATE, checkAntiRansomwareState);
  reportAntiRansomwareInfo();
}
function stopAntiRansomwareCheck() {
  if (IS_BROWSER) {
    return;
  }
  logger.ui.info('stopAntiRansomwareCheck');
  ipc.off(IpcEvents.VIRUS_CHECK_STATE, checkAntiRansomwareState);
  ipc.invoke(IpcEvents.VIRUS_CHECK, {
    startCheck: false,
  });
}

const { methods: coSyncMethods } = coSync;

const onLogin = () => {
  // 初始化主渲染进程中的同步数据库单例
  wsManager.createConnect();
  // 登录后刷一次未读消息数
  store.dispatch('UPDATE_MESSAGE_NUMBER');
  // 登录后更新用户设置
  store.dispatch('getUserSetting');

  // 私有化下不进行访问上报
  if (!IS_PRIVATE) {
    visitRequest();
    startAntiRansomwareCheck();
  }
  if (!IS_BROWSER) {
    transmissionDBManager.init();
  }

  if (coSyncMethods.isCoSyncEnable()) {
    coSyncMethods.onLogin(user.getUserInfoSync());
  }
};

const onLogout = async (type: 'logout' | 'switchOrg' = 'logout') => {
  if (coSyncMethods.isCoSyncEnable()) {
    await coSyncMethods.onLogout();
  }

  // 登出后要先关闭之前的连接（以免切换企业时复用之前的ws连接）
  wsManager.closeConnect();
  // 登出后创建无 userToken的连接

  wsManager.createConnect();
  cancelTask();
  delStorage();
  if (type === 'logout') {
    // 退出登录后清理本地 团队/个人空间/分享外链 AccessToken 缓存
    accessTokenManager.clear();
    shareAccessTokenManager.clear();
    // 登出后要将同意协议重置
    store.commit('SET_APPROVED_AGREEMENT', false);
  }
  visitScript?.parentNode?.removeChild(visitScript);
  stopAntiRansomwareCheck();

  if (!IS_BROWSER) {
    // 退出登录时清空当前用户所有table
    transmissionDBManager.clear(true);
  }
};
user.on('after-login', () => {
  onLogin();
});

// 切换身份
user.on('switch-org-started', async () => {
  await onLogout('switchOrg');
});

user.on('after-logout', async () => {
  await onLogout('logout');
});
window.onbeforeunload = (e: BeforeUnloadEvent) => {
  /* i18n-ignore*/
  console.log('刷新页面断开 websocket 连接');
  wsManager.closeConnect();
};

// 可以让 PC 端在 script 脚本中调用的函数
window.electronTools = {
  // 通过client.js脚本加载的强制升级弹窗可以通过initLanguage获取客户端当前语言环境
  initialLanguage: i18n.locale,
  /**
   * @description 挂载全局函数允许触发升级。【2.0.2 版本新增】
   * @param {boolean} silentUpdate 是否静默升级
   */
  upgradePCNow(silentUpdate: boolean) {
    ipc.emit(ipc.RENDERER_EVENTS_MAP.UPGRADE_PC_NOW, silentUpdate);
  },
};
